module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_salgadinho.661c7d8d.png";